/**
 * Created by User on 18/02/2016.
 */

import Utils from '../utils/Utils';
import IMAElement from './elements/IMAElement';
import YandexElement from './elements/YandexElement';
import AdElement from './elements/AdElement';

export default AdElementFactory;

function AdElementFactory() {

}
AdElementFactory.createElement = function(url) {
  var element;
  if (Utils.isURLisIMA(url)) {
    element = new IMAElement(url);
  } else if (Utils.isURLisYandex(url)) {
    element = new YandexElement(url);
  } else if (Utils.isStringWithData(url)) {
    element = new AdElement(url);
  }
  return element;
};
AdElementFactory.prototype.constructor = AdElementFactory;